export default "__VITE_ASSET__JlOi5NwU__"